module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Proposta',
        href: '#'
      }, {
        text: 'Deferimento',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": true
    }
  }, [_c('div', {
    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "ng-init": "check()"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.simplified),
      expression: "proposta.simplified"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "hidden",
      "name": "tipo",
      "id": "tipo",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.proposta.simplified)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "simplified", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Proposta ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
    }
  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('nome')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('NAME')"
    }
  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.idProjectErp",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.idProjectErp),
      expression: "proposta.idProjectErp"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "idProjectErp",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.proposta.idProjectErp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "idProjectErp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.name",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.name),
      expression: "proposta.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('nome do coordenador')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORNAME')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorName",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.coordinatorName),
      expression: "proposta.coordinatorName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome do coordenador",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.proposta.coordinatorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "coordinatorName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('cpf do coordenador')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORCPF')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorCpf",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.proposta.coordinatorCpf),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "coordinatorCpf", $$v)
      },
      expression: "proposta.coordinatorCpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('email do coordenador')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATOREMAIL')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorEmail",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.coordinatorEmail),
      expression: "proposta.coordinatorEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:255'),
      expression: "'required|email|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email do coordenador",
      "type": "email",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.coordinatorEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "coordinatorEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Telefone')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.coordinatorPhone),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "coordinatorPhone", $$v)
      },
      expression: "proposta.coordinatorPhone"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Telefone Celular')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Celular",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.coordinatorMobile),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "coordinatorMobile", $$v)
      },
      expression: "proposta.coordinatorMobile"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Telefone Fax')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Fax",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.coordinatorFax),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "coordinatorFax", $$v)
      },
      expression: "proposta.coordinatorFax"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Fax')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-md-offset-1"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
    staticClass: "proposal-definition-list"
  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.proposta.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.proposta.entity.address), function(addr) {
    return _c('address', {
      staticClass: "ng-binding ng-scope"
    }, [_vm._v("\n                                      " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                      " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                    ")])
  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.proposta.entity.email))])]), _vm._v(" "), _c('h2', {
    staticClass: "h4"
  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
    staticClass: " col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('Data Inicial')
    },
    staticStyle: {
      "margin-left": "-15px"
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('INITIALDATE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data inicial aqui")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.initialDate",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.initialDate),
      expression: "proposta.initialDate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Data Inicial",
      "input-class": "form-control",
      "type": "date",
      "format": "DD/MM/YYYY",
      "disabled": true
    },
    domProps: {
      "value": (_vm.proposta.initialDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "initialDate", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('periodo')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.periods",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.periods),
      expression: "proposta.periods"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1'),
      expression: "'required|min_value:1'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
    attrs: {
      "name": "periodo",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.proposta.periods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "periods", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field required-field col-md-12 ng-scope",
    class: {
      'has-error': _vm.errors.first('introducao')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
    }
  }, [_c('label', {
    staticClass: "control-label ",
    attrs: {
      "for": "introduction"
    }
  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.introduction",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.introduction),
      expression: "proposta.introduction"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
    attrs: {
      "name": "introducao",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "introduction", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('apresentacao')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('PRESENTATION')"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "presentation"
    }
  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.presentation",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.presentation),
      expression: "proposta.presentation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "apresentacao",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.presentation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "presentation", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('territorio')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('TERRITORY')"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "territory"
    }
  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.territory",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.territory),
      expression: "proposta.territory"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "territorio",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.territory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "territory", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('JUSTIFICATION')"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justification"
    }
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.justification",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.justification),
      expression: "proposta.justification"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "justificativa",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.justification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "justification", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('objetivo Geral')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('GENERALOBJECTIVE')"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "generalObjective"
    }
  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.generalObjective",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.generalObjective),
      expression: "proposta.generalObjective"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "objetivo Geral",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.generalObjective)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "generalObjective", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('sumario')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('SUMMARY')"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.summary",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.summary),
      expression: "proposta.summary"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "sumario",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "summary", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('publico-alvo', {
    attrs: {
      "propsPublicosGrid": this.proposta.audiences
    },
    on: {
      "publicoAlvoAdicionado": function($event) {
        _vm.proposta.audiences = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('equipe-projeto', {
    attrs: {
      "propsEquipes": this.proposta.teams
    },
    on: {
      "equipeAdicionada": function($event) {
        _vm.proposta.teams = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Resultados esperados')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "results"
    }
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.results",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.results),
      expression: "proposta.results"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Resultados esperados",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.results)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "results", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Operacionalização')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.operation",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.operation),
      expression: "proposta.operation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Operacionalização",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.operation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "operation", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('Parceria')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "partner"
    }
  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.partner",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.partner),
      expression: "proposta.partner"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Parceria",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.proposta.partner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "partner", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityIsExecutioner",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityIsExecutioner),
      expression: "proposta.entityIsExecutioner"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-true",
      "value": "true",
      "selected": _vm.proposta.entityIsExecutioner === 'true'
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "entityIsExecutioner", "true")
      }
    }
  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityIsExecutioner),
      expression: "proposta.entityIsExecutioner"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-false",
      "value": "false",
      "selected": _vm.proposta.entityIsExecutioner === 'false'
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.entityIsExecutioner, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "entityIsExecutioner", "false")
      }
    }
  }), _vm._v(" Não\n                                ")])])]), _vm._v(" "), (_vm.proposta.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field  col-md-12",
    class: {
      'has-error': _vm.errors.first('Nome Entidade Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingName),
      expression: "proposta.entityExecutingName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nome Entidade Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Representante legal')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingProcurator",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingProcurator),
      expression: "proposta.entityExecutingProcurator"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Representante legal",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingProcurator)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingProcurator", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ entidade executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCNPJ",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner|cnpj'),
      expression: "'required:!proposta.entityIsExecutioner|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ entidade executora",
      "type": "text",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.proposta.entityExecutingCNPJ),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingCNPJ", $$v)
      },
      expression: "proposta.entityExecutingCNPJ"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('E-mail executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingEmail",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingEmail),
      expression: "proposta.entityExecutingEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner|email'),
      expression: "'required:!proposta.entityIsExecutioner|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "E-mail executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.entityExecutingPhone),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingPhone", $$v)
      },
      expression: "proposta.entityExecutingPhone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone celular da executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingMobile",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone celular da executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.entityExecutingMobile),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingMobile", $$v)
      },
      expression: "proposta.entityExecutingMobile"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingFax",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "entityExecutingFax",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.entityExecutingFax),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingFax", $$v)
      },
      expression: "proposta.entityExecutingFax"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CEP da executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCEP",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CEP da executora",
      "type": "text",
      "mask": ['#####-###']
    },
    model: {
      value: (_vm.proposta.entityExecutingCEP),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
      },
      expression: "proposta.entityExecutingCEP"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('UF executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingState",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingState),
      expression: "proposta.entityExecutingState"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UF executora"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Cidade da Executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCity",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingCity),
      expression: "proposta.entityExecutingCity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cidade da Executora",
      "type": "text"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Endereço da Executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingAddress",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingAddress),
      expression: "proposta.entityExecutingAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Endereço da Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Projeto Duplicação')
    },
    attrs: {
      "uib-tooltip": "Projeto de duplicação"
    }
  }, [_c('div', {
    attrs: {
      "name": "proposal.duplicateProject",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.duplicateProject),
      expression: "proposta.duplicateProject"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto Duplicação",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.projectNumber
      }
    }, [_vm._v(_vm._s(projeto.projectNumber) + "/" + _vm._s(projeto.projectName))])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(7), _vm._v(" "), _c('objetivo-especifico', {
    attrs: {
      "propsObjetivos": _vm.proposta.objectives
    },
    on: {
      "objetivoAdicionado": function($event) {
        _vm.proposta.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(8), _vm._v(" "), _c('metas', {
    attrs: {
      "propsObjetivos": _vm.proposta.objectives
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.proposta.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(9), _vm._v(" "), _c('atividades', {
    attrs: {
      "meses": _vm.proposta.periods,
      "propsObjetivos": _vm.proposta.objectives
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.proposta.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraCronograma),
      expression: "mostraCronograma"
    }],
    staticClass: "col-md-12"
  }, [_vm._m(10), _vm._v(" "), _c('cronograma', {
    attrs: {
      "proposta": _vm.proposta,
      "propsObjetivos": _vm.proposta.objectives,
      "atividades": _vm.atividades,
      "meses": _vm.proposta.periods,
      "projeto-duplicacao": _vm.proposta.duplicateProject
    },
    on: {
      "itemAdicionado": function($event) {
        _vm.proposta.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('gantt', {
    attrs: {
      "periodo": _vm.proposta.periods,
      "propsObjetivos": _vm.proposta.objectives,
      "atividades": _vm.atividades
    }
  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('municipalizacao', {
    attrs: {
      "proposta": _vm.proposta
    },
    on: {
      "municipioAdicionado": function($event) {
        _vm.proposta = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(12), _vm._v(" "), _c('cursos', {
    attrs: {
      "propsCursos": _vm.proposta.careers
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(13), _vm._v(" "), _c('solenizacao', {
    on: {
      "solenizacaoAdicionada": function($event) {
        _vm.proposta.solemnizations = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(14), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.proposta.documents,
      "documentTypes": _vm.proposta.documentTypes,
      "documentosObrigatorios": _vm.documentosObrigatorios
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(15), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.proposta.documentStatements,
      "documentTypes": [],
      "documentosObrigatorios": []
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(16), _vm._v(" "), _c('historico-proposta', {
    attrs: {
      "proposta": _vm.proposta
    }
  })], 1)])]), _vm._v(" "), _c('deferimento', {
    attrs: {
      "propsAnalise": _vm.analise
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de Proposta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações introdutórias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Público-alvo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Equipe do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações Gerais")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entidade executora")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Projeto de duplicação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Objetivo Específico")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Metas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atividades")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma Físico-Financeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Municípios - Locais de execução")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cursos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Solenização")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à Fundação Banco do Brasil, não contar com\n                          outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil neste projeto.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de Aprovações:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66339272!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/mainDeferimento.vue
// module id = 1991
// module chunks = 1